import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import type { GlobalState } from "../../store";
import type { RecipientUser } from "@/types";

const initialState: RecipientUser = null as unknown as RecipientUser;

export const recipientUserState = createSlice({
  name: "recipientUser",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<RecipientUser>) => {
      return (state = action.payload);
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.recipientUser;
export const selectRecipientUser = createSelector(selector, (s) => s);

export default recipientUserState.reducer;
